<!-- <div *ngIf="!loading"> -->
    <div class="d-flex flex-wrap w-100 h-100">
    <div class="flex-1 w-100 h-100" #mapElement style="min-height: 350px; min-width: 100%; height: 100%;"></div>
    <div *ngIf="context === ''" class="scrollable flex-1 w-100" id="sidebar" style="max-height: 350px;">
        <div id="panel"></div>
      </div>
    </div>
    
    <!-- <google-map #map width="500px" [options]="mapOptions">
        <map-marker
        [position]="options?.center"></map-marker>
        </google-map> -->
  <!-- </div> -->